<template>
  <div class="info">
    <lb-table v-loading="loading" v-horizontal-scroll="'always'" :column="columns" :data="list" pagination
      :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage" :page-size="page.pageSize" @selection-change="onMultipleSelection"
      @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
    </lb-table>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    LbTable
  },
  props: {
    userId: Number
  },
  data() {
    return {
      loading: false,
      name: 'cdd',
      list: [],
      columns: [
        { label: '商品编号', prop: 'goodsNo', minWidth: '120' },
        { label: '商品名称', prop: 'name', minWidth: '220' },
        {
          label: '商品图片', prop: 'brandName', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <img style="width:160px;height:120px;" src={scope.row.image} />
              </div>
            )
          }
        },
        { label: '收藏时间', prop: 'storeTime', minWidth: '120' }
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' }
    }
  },
  created() {
    this.getCollectPageList()
  },
  watch: {
    userId: {
      handler(val) {
        this.page.pageNo = 1;
        this.userId = val
        this.getCollectPageList()
      },
      deep: true
    }
  },
  methods: {
    onMultipleSelection(e) { },
    handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getCollectPageList()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e;
      this.getCollectPageList()
    },
    getCollectPageList() {
      let data = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        id: this.userId
      }
      this.axios.post('/user/userInfo/store', data)
        .then(res => {
          if (res.code == 0) {
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    }
  }
}
</script>
<style scoped lang="scss">
.info {
  padding-top: 20px;
  padding-bottom: 20px;

  /deep/ .el-table .el-table__header .el-table__cell {
    padding: 0;
  }

  /deep/ .el-table .el-table__row .el-table__cell {
    color: #303033;
    font-weight: 400;
  }
}
</style>


